import Hero from "../components/Hero";
import MarketSummary from "../components/MarketSummary";
import WhyUs from "../components/WhyUs";
import Join from "../components/Join";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Hero />
      <MarketSummary />
      <WhyUs />
      <Join />
      <Footer />
    </>
  );
};
export default Home;
